<template>
<!-- 求留印记狗狗图片 -->
<div class="img-container">
	<!-- <img src="//image1.51tiangou.com/tgou2/img2/discover/gogomessage.png" alt=""> -->
</div>
</template>

<script>
export default{
	
}
</script>
